import { SxProps } from "@mui/material";

export const wrapperMain: SxProps = {
  "&>div:first-of-type": {
    width: "478px",
    maxWidth: "100%",
    margin: "0 auto",
  },
  "& .coin-row": {
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
    borderRadius: "8px",
    padding: "0 8px",
    "&:hover": {
      background: "rgba(60,70,119,0.9)",
    },
  },
  "& .coin-icon": {
    width: "32px",
    height: "32px",
  },
  "& h6 img:not('.loading')": {
    position: "relative",
    left: "8px",
    top: "7px",
  },
  "& .text_item": {
    color: "#9CA3AF",
    fontSize: "1.2rem",
    margin: "5px 0",
  },

  "& .starBox": {
    width: "145px",
    display: "flex",
    marginTop: "5px",
    transform: "rotate(180deg)",
    "& span": {
      background: "rgb(243, 156, 18)",
      width: "25px",
      height: "25px",
      borderRadius: "8px",
      display: "inline-block",
      margin: "2px",
      transition: "100ms",
      textAlign: "center",
      "& svg": {
        transition: "100ms",
        fill: "rgb(255, 255, 255)",
        transform: "rotate(180deg)",
        marginTop: "2px",
      },
    },
  },
  ".starBox:hover span": {
    background: "#dcdce6",
  },
  ".starBox span:hover": {
    background: "#f39c12",
  },
  ".starBox span:hover ~ span": {
    background: "#f39c12",
  },
  "& .ok": {
    padding: "0",
    "& svg": {
      color: "#2ecc71",
    },
  },
  "& .trust_wallet": {
    display: "none",
    "& button": {
      position: "relative",
      "& a": {
        position: "absolute",
        width: "100%",
        bottom: "0",
        top: "0",
      },
    },
  },
  "& .extra_item": {
    border: "1px solid #FF9800",
    borderRadius: "5px",
    padding: "5px 10px",
    margin: "7px auto",
    display: "flex",
    "&>p": {
      margin: "0",
    },
  },
  "@media (max-width: 768px)": {
    "& .trust_wallet": {
      display: "block",
    },
  },
};
export const wrapperHeader: SxProps = {
  width: "478px",
  maxWidth: "100%",
  display: "flex",
  justifyContent: "center",
  "& h5": {
    fontWeight: "700",
  },
  "& button:first-of-type": {
    position: "absolute",
    top: "28px",
    left: "13px",
    fontSize: "18px",
    color: "#ffffff",
  },

  "& svg": {
    color: "#ffffff",
  },
};

export const wrapperTopPart: SxProps = {
  justifyContent: "space-between",
  "& img": {
    borderRadius: "50%",
  },
};

export const wrapperItem: SxProps = {
  justifyContent: "space-between",
  width: "49%",
  "& p": {
    fontSize: "1rem",
  },
  "& h6": {
    fontWeight: "700",
    fontSize: "1.4rem",
  },
  "& h5": {
    fontWeight: "700",
    fontSize: "22px",
  },
};
export const wrapperIcons: SxProps = {
  display: "flex",
  padding: "15px 10px",
  "& img": {
    margin: "0 5px",
    position: "relative",
    top: "4px",
  },
  "& span": {
    opacity: "0.7",
  },
  borderBottom: "1px solid #FFFFFF21",
};

export const wrapperMiddle: SxProps = {
  justifyContent: "space-between",
  "& h6": {
    fontWeight: "700",
  },
};

export const wrapperAddress: SxProps = {
  justifyContent: "space-between",
  "& h6,& h5": {
    fontWeight: "700",
  },
};
